import { creatorbase } from '@round/api';
import { showNotification } from 'helpers';
import { backupPostsStatuses } from 'Modules/Plans/Posts/helpers';
import copyComponentRenderToClipboard from 'utility/copyToClipboard/copyComponentRenderToClipboard';
import YoutubeReportClipboardTable, {
    mapToClipboardReportRow,
    mapToClipboardTableTotals,
} from 'Modules/Plans/CopyToClipboard/projectReport/YoutubeReportClipboardTable';
import useProjectDetails from '../../useProjectDetails';
import { CampaignTableRow } from '../../components/ProjectCampaignsTable/ProjectCampaignsTable';
import { useEnsureProjectDetailsYoutubePosts } from '../posts/useProjectDetailsYoutubePosts';

export default function useCopyYoutubeReportToClipboard() {
    const ensurePosts = useEnsureProjectDetailsYoutubePosts();
    const { project, brand } = useProjectDetails();

    return async (campaign: CampaignTableRow, includeCost: boolean) => {
        try {
            const rows = await ensurePosts(campaign.id);

            const items = rows
                .filter((row) => !backupPostsStatuses.includes(row.status as creatorbase.BackupPostStatus))
                .map((row) => mapToClipboardReportRow({ post: row, channel: row.channel }));

            const totals = mapToClipboardTableTotals(campaign.stats, items, campaign);
            const success = copyComponentRenderToClipboard(
                {
                    artistName: brand?.name,
                    projectName: project?.name,
                    campaignName: campaign.name,
                    currency: campaign.currency,
                    totals,
                    items,
                    includeCost,
                },
                YoutubeReportClipboardTable
            );

            showNotification(success ? 'Copied!' : 'Could not copy', success ? 'info' : 'error');
        } catch {
            showNotification('Could not copy', 'error');
        }
    };
}
